import { render, staticRenderFns } from "./PVrmLookup.vue?vue&type=template&id=539feecc&"
import script from "./PVrmLookup.vue?vue&type=script&lang=js&"
export * from "./PVrmLookup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports